import { Link } from "@/components/common/Link";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const rightsData = [{
  id: "access",
  title: "Right to Access",
  content: "You have the right to request copies of your personal data. We may charge you a small fee for this service to cover administrative costs associated with retrieving and compiling your information."
}, {
  id: "rectification",
  title: "Right to Rectification",
  content: "You have the right to request that we correct any information you believe is inaccurate. You also have the right to request that we complete the information you believe is incomplete, ensuring your data remains current and precise."
}, {
  id: "erasure",
  title: "Right to Erasure",
  content: "You have the right to request that we erase your personal data, under certain conditions. This is also known as the 'right to be forgotten', allowing you to manage your digital footprint within our systems."
}, {
  id: "restriction",
  title: "Right to Restriction",
  content: "You have the right to request that we restrict the processing of your personal data, under certain conditions. This allows you to limit how we use your data if you have concerns about its accuracy or the lawfulness of the processing."
}];
export default function UserRights() {
  return <section id="user-rights" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 max-w-3xl">
        <div className="mb-12 text-center">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-foreground mb-4">
            User Rights & Data Control
          </h2>
          <p className="font-sans text-muted-foreground text-lg">
            We are committed to ensuring that your information is secure and your
            privacy rights are fully respected.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-4">
          {rightsData.map((right, i) => <AccordionItem key={right.id} value={right.id} data-index={i} className="border-2 border-border rounded-none bg-card px-6 transition-colors data-[state=open]:border-ring">
              <AccordionTrigger className="font-serif font-semibold text-lg text-foreground hover:no-underline py-6">
                {right.title}
              </AccordionTrigger>
              <AccordionContent className="font-sans text-muted-foreground text-base leading-relaxed pb-6">
                {right.content}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>

        <div className="mt-12 p-8 border-2 border-border bg-muted/20 text-center rounded-none">
          <p className="font-sans text-foreground mb-4 text-lg">
            To exercise any of these rights or for further inquiries, please contact us:
          </p>
          <Link to="mailto:privacy@example.com" className="font-mono text-ring font-medium relative inline-block pb-1 after:content-[''] after:absolute after:w-full after:scale-x-0 after:h-[1px] after:bottom-0 after:left-0 after:bg-ring after:origin-bottom-right after:transition-transform after:duration-300 hover:after:scale-x-100 hover:after:origin-bottom-left">
            privacy@example.com
          </Link>
        </div>
      </div>
    </section>;
}